import { get } from '../../../../utils/api/api';
import { PER_PAGE } from '../constants';
import { getInitialLanguage } from '../../../../translations/utils';

const cachedRequests = {};

export default async function getDrawingResultWinners({ page = 1 } = {}) {
  const key = `${getInitialLanguage()}-${page}`;
  if (cachedRequests[key]) return cachedRequests[key];
  return (cachedRequests[key] = await get(
    `/data/winners/?page=${page}&per-page=${PER_PAGE}`,
    {},
    { apmCustomErrorMessage: 'Не удалось получить список победителей розыгрыша' },
  ));
}
